import React,{useState,useEffect} from 'react';
import {Offcanvas, Image} from 'react-bootstrap';
import { useLanguage } from '../i18n/LanguageContext';
import { loadAndParseXml } from '../i18n/xmlLoader';

function Commentary(props){
  const { language, t } = useLanguage();
  const [show, setShow] = useState(props.show);
  var card = props.card;
 
  var title, summary, commentary;

  if (card != null && card != "cover"){
    loadAndParseXml(card + ".xml", language, function (err, result) {
      try{
        title = result.card.title[0];
        summary = result.card.summary[0];
        commentary = result.card.commentary[0];
        if (props.onLoad) props.onLoad(title);
      }
      catch(ex){
        alert(t('common.cannotReadCard', { card }));
      }
    });
  }

  function handleClose(){
    setShow(false);
    props.onHide();
  } 

  const handleShow = () => setShow(true);
  var currentCardPath = "cards/" + card + ".jpg";
  return (
    <Offcanvas show={show} onHide={handleClose} {...props}>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>{title}</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <div style={{overflowY:'auto', textAlign:'center'}}>
        <div><Image src={currentCardPath} thumbnail style={{overflow:'hidden', height: 'calc(100vh - 230px - env(safe-area-inset-top) - env(safe-area-inset-bottom)) * 0.7', maxHeight:'600px', minHeight:'300px', minWidth:'250px', width:'calc((100vh - 230px - env(safe-area-inset-top) - env(safe-area-inset-bottom))*0.7 * 0.7)'}} /></div>
        <p></p>
        <div style={{textAlign:'left'}}>{summary}</div>
          <p></p>
          <p><b style={{color:'black'}}>{t('common.commentary')}</b></p>
          <div style={{textAlign:'left'}}>{commentary}</div>
      </div>
    </Offcanvas.Body>
  </Offcanvas>
  )

  

};

export default Commentary;